/**
 * Environment variables to prevent ANSI escape codes from being output by
 * terminal tools. Use these when spawning processes to reduce the need for
 * post-processing with stripAnsiCodes.
 */
export const DUMB_TERMINAL_ENVS = {
  NO_COLOR: "1", // Standard opt-out for colored output
  FORCE_COLOR: "0", // Ensures tools like chalk suppress color
  TERM: "dumb", // Prevents terminal formatting
} as const;

/**
 * Strips ANSI escape codes (color codes, etc.) from a string.
 * Useful for cleaning terminal output.
 */
export function stripAnsiCodes(message: string): string {
  return message
    .replace(/\x1b\[[\d;]*m/g, "") // Remove color codes
    .trim();
}

/**
 * Quotes a value for safe interpolation into a POSIX `sh` command string.
 * Single-quotes the value and escapes embedded single quotes via the
 * close-quote / escaped-quote / reopen-quote idiom (`'\''`), so shell
 * metacharacters in caller-controlled input can't break out of the literal.
 */
export function shellQuote(value: string): string {
  return `'${value.replaceAll("'", "'\\''")}'`;
}
